module.exports = __webpack_public_path__ + "img/cloud07.8b923e34.png";